export const PositiveNumber = (errorMessage: string) => (value: number) => 
    value > 0 || errorMessage;

export const ZeroOrPositiveNumber = (errorMessage: string) => (value: number) =>
    value >= 0 || errorMessage;

export const NumberRangeInclusive = (min: number, max: number, errorMessage: string) =>
    (value: number) => value >= min && value <= max || errorMessage;